import React from 'react';

const defaultCheckIcon = (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
        <path d="M20 6L9 17l-5-5" />
    </svg>
);

const HighlightList = ({
    items,
    listClassName,
    itemClassName,
    iconWrapperClassName,
    icon = defaultCheckIcon
}) => (
    <div className={listClassName}>
        {items.map((item) => (
            <div key={item} className={itemClassName}>
                <div className={iconWrapperClassName}>{icon}</div>
                <span>{item}</span>
            </div>
        ))}
    </div>
);

export default HighlightList;
